import React, { useContext, useEffect, useState } from "react";
import "./UiConfig.css";
import UiConfigSidebar from "../../components/uiConfigSidebar/UiConfigSidebar";
import Preview from "../preview/Preview";
import { useUiConfigOption } from "../../providers/UiConfigOptionProvider";
import { fetchAllRoles } from "../../services/userService";
import { setManageRoleState } from "../../stateManagement/actions/manageRoleAction";
import { Role } from "../../components/userModal/userModalType";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { useNavigate } from "react-router-dom";
import {
  getMetaData,
  getMetaDataConfig,
  getNewConfiguration,
} from "../../services/uiConfigService";
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import NewPortalLayout, {
  ConfigOptionsContext,
} from "../../components/newPortal/NewPortalLayout";
import { configurationAttributeType } from "../../types";
import * as Sentry from "@sentry/react";
import OptionalFeatureLayout from "../salescodeStudio/mandatoryConfigs/optionalFeatures/OptionalFeatureLayout";
import Loader from "../../components/loading/Loader";

const UiConfig = () => {
  const [loader, setIsloader] = useState<boolean>(false);
  const navigate = useNavigate();
  const { activeOption } = useUiConfigOption();

  useEffect(() => {
    async function getAndSetRoles() {
      const appRoles: string[] = [];
      const clientConfig = await getMetaDataConfig("clientconfig");
      clientConfig.forEach((configObj: { domainType: string }) => {
        if (configObj.domainType.endsWith("app_feature_configuration")) {
          const index = configObj.domainType.lastIndexOf("app");
          const roleName = configObj.domainType.substring(0, index - 1);
          appRoles.push(roleName);
        }
      });
      setManageRoleState({ allRoles: appRoles });
      if (appRoles.length === 0) {
        openPopup(
          "Alert",
          "First create atleast one role for App to access UI Config",
          () => {
            navigate("/dashboard/manageRole");
          }
        );
      }
    }
    getAndSetRoles();
    logEvent(eventEnum.ui_config_click, {
      feature_name: "UI config",
      dashboard_name: "Salescode studio",
    });
  }, []);

  return (
    <>
      {loader ? (
        <>
          <Loader></Loader>
        </>
      ) : (
        <div className="main_container">
          <UiConfigSidebar /> {/* Standard subscription sidebar */}
          <div className="content_container">
            {activeOption.targetComponent}
          </div>
          <div className="preview_container">
            <Preview />
          </div>
        </div>
      )}
    </>
  );
};

export default UiConfig;
